'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_UserPreferences(timeZoneId) {
  this.Su = null;
  this.Su = timeZoneId;
}
export { $c_Lmealorama_UserPreferences as $c_Lmealorama_UserPreferences };
$p = $c_Lmealorama_UserPreferences.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_UserPreferences;
/** @constructor */
function $h_Lmealorama_UserPreferences() {
}
export { $h_Lmealorama_UserPreferences as $h_Lmealorama_UserPreferences };
$h_Lmealorama_UserPreferences.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 785366537, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_UserPreferences)) {
    var x = this.Su;
    var x$2 = x$0.Su;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "UserPreferences";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Su;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_UserPreferences(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k5)));
}
export { $isArrayOf_Lmealorama_UserPreferences as $isArrayOf_Lmealorama_UserPreferences };
var $d_Lmealorama_UserPreferences = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_UserPreferences, "mealorama.UserPreferences", ({
  k5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_UserPreferences as $d_Lmealorama_UserPreferences };
//# sourceMappingURL=mealorama.-User-Preferences.js.map
